import * as React from 'react';
import cn from 'clsx';
import { Image, ArticleHeading1, IconSuccess16, UIText1, UIHeading2 } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { BigHeading } from '../BigHeading/BigHeading';
import { PERSONAL_MANAGERS, IMAGE_SIZE } from './constants';
import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../constants/mediaQueries';

import * as styles from './styles.css';

const PersonalManagersSection: React.FC<React.PropsWithChildren<IWithDeviceTypeProps>> = ({ isPhone, deviceType }) => {
  const imageSize = IMAGE_SIZE[deviceType];
  const Heading = isPhone ? ArticleHeading1 : BigHeading;
  const ManagerName = isPhone ? UIText1 : UIHeading2;

  return (
    <div>
      <Heading as="h2">На каждом этапе с вами будет персональный помощник</Heading>
      <div className={cn(styles['description'], styles[deviceType])}>
        <div className={styles['icon']} aria-hidden>
          <IconSuccess16 />
        </div>
        <UIText1 fontWeight={isPhone ? 'normal' : 'bold'}>
          Вас сопровождают опытные персональные помощники, специализирующиеся на оформлении электронной регистрации в
          Росреестре с 2015 года.
        </UIText1>
      </div>
      <div className={cn(styles['managers-container'], styles[deviceType])}>
        <ul className={cn(styles['managers-list'], styles[deviceType])}>
          {PERSONAL_MANAGERS.map((m, i) => (
            <li key={i} className={styles['manager']}>
              <div className={styles['image']}>
                <Image
                  width={imageSize}
                  height={imageSize}
                  sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: m.image.x2 }, { srcset: m.image.x1 }]}
                  src={m.image.x1}
                  loading="lazy"
                />
              </div>
              <ManagerName fontWeight="bold">{m.name}</ManagerName>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const PersonalManagersSectionWithDeviceType = withDeviceType(PersonalManagersSection);
export { PersonalManagersSectionWithDeviceType as PersonalManagersSection };
